import {Utils} from "../Modules/Utils";
// @ts-ignore
import debounce from 'lodash/debounce';

Utils.executeWhenDocumentIsReady(() => {

    const metaToggles: NodeListOf<HTMLInputElement> = document.querySelectorAll('[data-meta-toggle]');
    const metaTargets: NodeListOf<HTMLInputElement> = document.querySelectorAll('[data-meta-target]');

    metaToggles.forEach((toggle) => {
        toggle.addEventListener('click', () => {
            if (toggle.checked) {
                metaToggles.forEach((t) => {
                    t.checked = false;
                });
                toggle.checked = true;
            }
        });
    });

    metaTargets.forEach((target) => {
        target.setAttribute('style', '--max-width: ' + target.scrollWidth + 'px');
    });

    window.addEventListener('resize', debounce(() => {
      metaTargets.forEach((target) => {
        target.setAttribute('style', '--max-width: ' + target.scrollWidth + 'px');
      });
    }, 100));
});
